import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "login-card" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "error-message"
}

import { ref, computed, onMounted } from 'vue'
import { 
  IonPage, 
  IonContent, 
  IonInput, 
  IonLabel, 
  IonButton, 
  IonNote,
  IonIcon,
  IonSpinner
} from '@ionic/vue'
import { useRouter } from 'vue-router'
import { AuthService } from '../services/AuthService'


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const router = useRouter()

// Form data
const email = ref('')
const code = ref('')
const isLoading = ref(false)

// Error states
const emailError = ref('')
const codeError = ref('')
const generalError = ref('')

// Form validation
const isFormValid = computed(() => {
  return email.value.trim() !== '' && 
         code.value.trim() !== '' && 
         code.value.length === 6 &&
         !emailError.value && 
         !codeError.value
})

// Clear specific error
const clearError = (field: string) => {
  if (field === 'email') emailError.value = ''
  if (field === 'code') codeError.value = ''
  generalError.value = ''
}

// Validate form
const validateForm = () => {
  let isValid = true
  
  // Clear previous errors
  emailError.value = ''
  codeError.value = ''
  generalError.value = ''
  
  // Validate email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!email.value.trim()) {
    emailError.value = 'Email is required'
    isValid = false
  } else if (!emailRegex.test(email.value)) {
    emailError.value = 'Please enter a valid email'
    isValid = false
  }
  
  // Validate code
  if (!code.value.trim()) {
    codeError.value = 'Access code is required'
    isValid = false
  } else if (code.value.length !== 6) {
    codeError.value = 'Code must be 6 digits'
    isValid = false
  } else if (!/^\d{6}$/.test(code.value)) {
    codeError.value = 'Code must contain only numbers'
    isValid = false
  }
  
  return isValid
}

// Handle login
const handleLogin = async () => {
  if (!validateForm()) return
  
  isLoading.value = true
  generalError.value = ''

  console.log('Email:', email.value);
  
  try {
    const success = await AuthService.login(email.value.trim(), code.value.trim())
    
    if (success) {
      // Redirect to main app
      router.push('/tabs')
    } else {
      generalError.value = 'Invalid email or code. Please try again.'
    }
  } catch (error: any) {
    console.error('HandleLogin error:', error)
    generalError.value = error.message || 'Login failed. Please try again.'
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { class: "login-content" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "login-header" }, [
                _createElementVNode("h1", null, "WalkyWalky"),
                _createElementVNode("p", null, "Enter your email and access code to continue")
              ], -1)),
              _createElementVNode("form", {
                onSubmit: _withModifiers(handleLogin, ["prevent"]),
                class: "login-form",
                autocomplete: "on"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Email", -1)
                    ])),
                    _: 1,
                    __: [4]
                  }),
                  _createVNode(_unref(IonInput), {
                    modelValue: email.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                    type: "email",
                    name: "email",
                    id: "email",
                    placeholder: "Enter your email",
                    autocomplete: "email",
                    class: _normalizeClass({ 'ion-invalid': emailError.value }),
                    onIonInput: _cache[1] || (_cache[1] = ($event: any) => (clearError('email'))),
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  (emailError.value)
                    ? (_openBlock(), _createBlock(_unref(IonNote), {
                        key: 0,
                        color: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(emailError.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(IonLabel), { position: "stacked" }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Access Code", -1)
                    ])),
                    _: 1,
                    __: [5]
                  }),
                  _createVNode(_unref(IonInput), {
                    modelValue: code.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((code).value = $event)),
                    type: "text",
                    placeholder: "Enter 6-digit code",
                    maxlength: "6",
                    class: _normalizeClass({ 'ion-invalid': codeError.value }),
                    onIonInput: _cache[3] || (_cache[3] = ($event: any) => (clearError('code'))),
                    required: ""
                  }, null, 8, ["modelValue", "class"]),
                  (codeError.value)
                    ? (_openBlock(), _createBlock(_unref(IonNote), {
                        key: 0,
                        color: "danger"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(codeError.value), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_unref(IonButton), {
                  type: "submit",
                  expand: "block",
                  disabled: isLoading.value || !isFormValid.value,
                  class: "login-button"
                }, {
                  default: _withCtx(() => [
                    (isLoading.value)
                      ? (_openBlock(), _createBlock(_unref(IonSpinner), {
                          key: 0,
                          name: "crescent"
                        }))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, "Login"))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ], 32),
              (generalError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(IonIcon), { name: "alert-circle" }),
                    _createTextVNode(" " + _toDisplayString(generalError.value), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})